
import React, { useEffect, useRef, useState } from 'react'
import { Modal as BSModal, ModalProps } from 'react-bootstrap'

import Times from '@/Components/SvgImages/Times';

import './Modal.scss'

interface Props extends ModalProps {
  show: boolean
  title?: string
  showCloseButton?: boolean
  onClose?: () => void

  children: any
}

const Modal = (props: Props) => {

  const { show, title, onClose, showCloseButton, children, className, ...rest } = props

  return (
    <BSModal
      show={show}
      onHide={onClose}
      className={`app-modal ${className}`}
      {...rest}
    >
      <BSModal.Header>
        {title && (
          <BSModal.Title>{props.title}</BSModal.Title>
        )}
        {showCloseButton && (
          <button className="modal-options-button"
            onClick={onClose}
          >
            <Times
              height={24}
              width={24}
            />
          </button>
        )}
      </BSModal.Header>
      <BSModal.Body>
        {children}
      </BSModal.Body>
    </BSModal>
  )
}

export default Modal

